import { render, staticRenderFns } from "./p23.vue?vue&type=template&id=af07bcde&scoped=true&"
import script from "./p23.vue?vue&type=script&lang=js&"
export * from "./p23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af07bcde",
  null
  
)

export default component.exports